module.exports = __webpack_public_path__ + "static/media/Handheld1.0af628e4.jpeg";